export function safeFilename(name: string, fallback = "download"): string {
  const s = (name ?? "").toString();
  const cleaned = s
    .replace(/[\0-\x1F\x7F]/g, "") // control chars
    .replace(/[\\/:*?"<>|]/g, "") // invalid FS chars
    .trim()
    .slice(0, 128);
  return cleaned || fallback;
}

// Allow only blob: (we create these) and https: (plus http: for localhost/dev)
export function isSafeHref(href: string): boolean {
  try {
    const u = new URL(href, window.location.origin);
    if (u.protocol === "blob:") return true;
    if (u.protocol === "https:") return true;
    if (u.protocol === "http:" && ["localhost", "127.0.0.1"].includes(u.hostname)) return true;
    return false;
  } catch {
    return false;
  }
}
